<ng-container *transloco="let t">
  <authority-labs-check-case
    (dataChange)="onDataChange()"
    [printPreview]="printPreview"
    [readonly]="readonly"
    [inspection]="shutdownPumpDetails"
    [fieldSection]="fieldSection"
  >
    <main class="input">
      <div *ngIf="printPreview">
        <mat-card
          class="mat-elevation-z4"
          *ngFor="let item of shutdownPumpDetails?.testData; let ind = index"
        >
          <mat-card-header>
            <mat-card-title
              >{{ t('inspection.fields.shutdownPump:test') }} {{ ind + 1
              }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <ng-container
              *ngTemplateOutlet="formTpl; context: { item: item, ind: ind }"
            ></ng-container>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-tab-group
        class="mat-elevation-z4"
        [(selectedIndex)]="selectedTab"
        *ngIf="!printPreview"
      >
        <mat-tab
          *ngFor="let item of shutdownPumpDetails?.testData; let ind = index"
        >
          <ng-template mat-tab-label>
            <mat-icon class="fail" color="warn" *ngIf="!item.isPassed">
              priority_high
            </mat-icon>
            <span
              >{{ t('inspection.fields.shutdownPump:test') }} {{ ind + 1
              }}</span
            >
          </ng-template>
          <ng-template matTabContent>
            <div [style.margin-right]="readonly || printPreview ? '45px' : '0'">
              <ng-container
                *ngTemplateOutlet="formTpl; context: { item: item, ind: ind }"
              ></ng-container>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </main>
  </authority-labs-check-case>

  <ng-template #formTpl let-item="item" let-ind="ind">
    <section>
      <div>
        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{ t('inspection.fields.staticPressure') }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [(ngModel)]="item.staticPressure"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>
        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{ t('inspection.fields.residualPressure') }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [(ngModel)]="item.residualPressure"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>
        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{ t('inspection.fields.flowRate') }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [(ngModel)]="item.flowRate"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          />
          <span class="prefix" matSuffix>gpm</span>
        </mat-form-field>
      </div>
      <button
        *ngIf="!(readonly || printPreview)"
        class="remove-btn"
        mat-raised-button
        aria-label="remove"
        [disabled]="shutdownPumpDetails.testData.length === 1"
        (click)="removePump(ind)"
      >
        <span>{{ t('inspection.fields.plans:remove') }}</span>
      </button>
      <button
        *ngIf="!(readonly || printPreview)"
        class="add-btn"
        mat-raised-button
        color="accent"
        aria-label="add"
        (click)="addPump()"
      >
        <span>{{ t('inspection.fields.shutdownPump:addTest') }}</span>
      </button>
    </section>
  </ng-template>
</ng-container>
